import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProductReviewListLoad } from '../../../../actionCreators/review';
import Stars from '../../../../CommonComponents/StarRating/StarRating';
import useInfiniteScroll from '../../../../utils/useInfiniteScroll';
import BlankLoader from '../../BlankLoader/BlankLoader';
import LKModal from '../../Modal/Modal';
import Review from './Review';
import './reviewList.scss';
import WriteReview from './WriteReview';

let page = 1;
function ReviewList(props) {
  const {
    productData,
    frameShape,
    frameType,
    contactLensPowerFromUrl,
    productId,
    showReviewFn,
    writeMode,
    dataLocale,
    reviewConfig,
  } = props;
  const { REVIEWS, WRITE_A_REVIEW, SEE_ALL_REVIEWS } = dataLocale;
  const { frameColour, type } = productData;
  const dispatch = useDispatch();
  const userRatingRef = useRef();
  const pageCount = 10;
  const { productReviewList, isReviewListLoading, reviewPageSize } = useSelector(
    state => state.review
  );
  const [writeReviewState, setWriteReviewState] = useState(writeMode);

  const getMoreReviews = () => {
    const { numberOfReviews } = productReviewList?.result;
    const totalPages = Math.ceil(numberOfReviews / reviewPageSize);
    if (page < totalPages) {
      const { productId } = props;
      page++;
      dispatch(getProductReviewListLoad({ productId, page, pageCount }));
    }
  };

  const [setIsFetching] = useInfiniteScroll(getMoreReviews, userRatingRef);

  useEffect(() => {
    if (!isReviewListLoading) {
      setIsFetching(false);
    }
  }, [isReviewListLoading]);

  return (
    <LKModal
      backdrop
      keyboard
      bodyClassName="padding-0"
      hideHandler={() => showReviewFn()}
      showModal="true"
      size="medium"
    >
      <div className="review-list">
        <div className={!writeReviewState ? 'display-block' : 'display-none'}>
          <div className="product-rating padding-40">
            <div className="display-flex align-items-center">
              <div className="review-title fs28">
                {REVIEWS} ({productReviewList?.result?.numberOfReviews})
              </div>
              <div onClick={() => showReviewFn()}>
                <img alt="close" className="cursor-pointer" src="/assets/svg/Cross.svg" />
              </div>
            </div>
            <div className="product-rating-info margin-t40 fw500">
              <div className="display-flex justify-space-between align-items-center">
                {productData.brandName && (
                  <div className="fs14 text-color_pale_black product-name fw-bold">
                    {productData.brandName}
                  </div>
                )}
                {productReviewList?.result?.avgRating && (
                  <Stars
                    defaultRating={Math.round(productReviewList?.result?.avgRating)}
                    ratingid={props.productId}
                  ></Stars>
                )}
              </div>
              <div className="display-flex justify-space-between margin-t10">
                {productData.classification === 'eyeframe' ||
                productData.classification === 'sunglasses' ? (
                  <div className="fs16 text-color_grey_black fw-bold">
                    {frameColour} {frameType} {frameShape} {type}
                  </div>
                ) : (
                  <div className="fs16 text-color_grey_black fw-bold">
                    {productData.fullName} {contactLensPowerFromUrl}
                  </div>
                )}
                <div
                  className="fs14 review-text fw-bold cursor-pointer"
                  onClick={() => setWriteReviewState(!writeReviewState)}
                >
                  {!writeReviewState ? WRITE_A_REVIEW : SEE_ALL_REVIEWS}
                </div>
              </div>
            </div>
          </div>
          <div
            ref={userRatingRef}
            className="user-ratings padding-t20 padding-l40 padding-r40 padding-b20"
          >
            {productReviewList?.result?.review?.reviews.map(review => {
              const {
                reviewId,
                noOfStars,
                reviewTitle,
                reviewDate,
                reviewDetail,
                reviewee,
                images,
              } = review;
              return (
                <Review
                  key={reviewId}
                  className="padding-t15 padding-b15"
                  images={images}
                  noOfStars={noOfStars}
                  reviewDate={reviewDate}
                  reviewDetail={reviewDetail}
                  reviewId={reviewId}
                  reviewTitle={reviewTitle}
                  reviewee={reviewee}
                />
              );
            })}
            {isReviewListLoading && <BlankLoader />}
          </div>
        </div>
        {writeReviewState && (
          <WriteReview
            dataLocale={dataLocale}
            productId={productId}
            reviewConfig={reviewConfig}
            showReviewFn={showReviewFn}
          />
        )}
      </div>
    </LKModal>
  );
}

export default ReviewList;
